<template>
  <q-dialog v-model="showDialog" seamless position="top">
    <q-card class="bg-warning" style="width: 420px;">
      <q-card-section class="q-pa-xs">
        <div class="text-center">
          <div v-if="!isOnline" class="text-weight-bold">
            <q-icon name="warning"/>
            It looks like you're offline.<br>Please check your internet
            connection or try to <a href="#" @click.prevent="reload">reload</a>.
          </div>
          <div v-else-if="isNetworkError">
            <q-icon name="warning"/>
            Cannot connect to server.<br>Please check your internet connection or try to
            <a href="#" @click.prevent="reload">reload</a>.
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
<script setup>
import { computed, inject } from 'vue';
import { useOnline } from '@vueuse/core';

const $store = inject('store');
const isOnline = useOnline();
const isNetworkError = computed(() => $store.getters['notifications/networkError']);
const showDialog = computed(() => !isOnline.value || isNetworkError.value);
const reload = () => window.location.reload();
</script>
